import { Id, LaravelResponse, PaginatedListFetcherConfig, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	AccessTokenCreateRequest,
	AccessTokenIndexResource,
	AccessTokenPermissionsFormValues,
	AccessTokenResource,
	CreatedAccessTokenResource,
} from "../types/accessToken";

const baseKey = ["access-tokens"];

export const accessTokenService = {
	indexKey: [...baseKey],
	listKey: [...baseKey, "list"],
	showKey: (id: Id) => [...baseKey, `${id}`],
	index: (config: PaginatedListFetcherConfig<AccessTokenIndexResource>) =>
		axios.get<LaravelResponse<AccessTokenIndexResource[]>>(keyToUrl(baseKey), {
			params: { ...config.searchParams, ...config.pageParams },
		}),
	show: (id: Id) => axios.get<LaravelResponse<AccessTokenResource>>(`${keyToUrl(baseKey)}/${id}`),
	create: (data: AccessTokenCreateRequest) =>
		axios.post<LaravelResponse<CreatedAccessTokenResource>>(keyToUrl(baseKey), data),
	destroy: (id: Id) => axios.delete(`${keyToUrl(baseKey)}/${id}`),
	syncPermissions: (id: Id, data: AccessTokenPermissionsFormValues) =>
		axios.put<LaravelResponse<void>>(`${keyToUrl(baseKey)}/${id}/permissions`, data),
};
